import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import LoadIcon from '../../components/LoadIcon'
import config from '../../config'
import closeTheatre from '../../images/mobile/close-theatre.png'
import openTheatre from '../../images/mobile/open-theatre.png'
import screen from '../../images/mobile/screen.png'
import { COLORS } from '../../styles/theme'
import Amplitude from '../../utils/amplitudeHelper'
import { useAutoMute } from '../../utils/useAutoMute'

const MobileAuditorium = ({ currentUser, liveUrl, hallNumber }) => {
  useAutoMute()
  const [isLoading, setIsLoading] = useState(true)
  const [theatre, setTheatre] = useState(false)

  useEffect(() => {
    Amplitude.visit(`Lecture Hall ${hallNumber}`)
    Amplitude.visitTemp(`Lecture Hall ${hallNumber}`)
  }, [currentUser.id, hallNumber])

  const videoContainerTheatreStyle = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'black',
    zIndex: '99',
  }

  return (
    <Page>
      <div className="outer-wrapper">
        <div className="container">
          <div className="screen-container">
            <img src={screen} className="screen" alt="screen" />
            <div className="video-container" style={theatre ? videoContainerTheatreStyle : {}}>
              {isLoading && <LoadIcon />}
              <iframe
                title="Live Broadcast"
                src={`${liveUrl}?autoplay=1`}
                allow="autoplay; fullscreen"
                allowFullScreen
                frameBorder="0"
                onLoad={() => {
                  setIsLoading(false)
                }}
              />
            </div>
          </div>

          <button type="button" className="theatre-button" onClick={() => setTheatre(true)}>
            <img src={openTheatre} className="theatre-button-icon" alt="theatre-icon" />
            <p className="theatre-button-label">Theatre mode</p>
          </button>
        </div>

        {/* <div className="chat-container">
          <ChatSection currentUser={currentUser} firebaseDb={HallOneDb} chatDb={ChatDb} />
        </div> */}

        {theatre && (
          <div className="theatre-close">
            <img src={closeTheatre} onClick={() => setTheatre(false)} className="theatre-close-icon" alt="close-icon" />
          </div>
        )}
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: url(${config.assets.auditorium1.portrait});
  background-size: cover;
  background-position: 50% 50%;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 95%;
    margin: auto;
  }

  .programme-btn {
    margin-right: 10px;
  }

  .faculty-btn {
    margin-left: 10px;
  }
  .toggle-live-btn {
    animation: bounce 1500ms infinite;
  }
  .action-button {
    width: 100%;
    background: #f87949;
    border-radius: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${COLORS.hotButtonText};
    border: 2px solid ${COLORS.hotButtonText};
    padding: 4px 10px;
    font-size: 14px;
    small {
      font-weight: 500;
    }
  }
  #check-in-btn {
    width: 50%;
    background: #f85d49;
    margin: 20px auto;
    padding: 6px 24px;
    font-size: 16px;
    small {
      margin-left: 8px;
    }
  }
  #tooltip {
    background: #000;
    padding: 8px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    .tooltip-text {
      font-size: 70%;
      padding-left: 12px;
      margin: 0;
    }
  }

  .programme-wrap {
    display: flex;
    margin-top: 15px;
    justify-content: space-between;
  }

  .button-container {
    width: 100%;
    display: grid;
    grid-gap: 12px;
    margin: 15px 0;
  }

  .screen-container {
    width: 100%;
    height: 0;
    padding-bottom: 58.5%;
    position: relative;
  }

  .screen {
    width: 100%;
    position: absolute;
  }

  .video-container {
    width: 92%;
    height: 81%;
    background: #1e1e1e;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50.5%, -51%);

    iframe {
      height: 100%;
      width: 100%;
    }
  }

  .title {
    width: 100%;
    margin: 20px 0px;
  }

  .chat-container {
    width: 100%;
    height: 700px;
    margin-top: 36px;
  }

  .theatre-button {
    width: 140px;
    height: 30px;
    background: black;
    margin: 10px 10px 0px 0px;
    float: right;
    border: none;
    border-radius: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    opacity: 0.6;
    padding: 0;
  }

  .theatre-button-label {
    color: white;
    font-size: 12px;
    margin: 0px 10px 0px 0px;
  }

  .theatre-button-icon {
    width: 20px;
    margin: 0px 10px;
  }

  .theatre-close {
    color: white;
    background: black;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 99;
    opacity: 0.6;
  }

  .theatre-close-icon {
    width: 20px;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      /* width: 540px; */
      margin: auto;
    }
  }
`

export default MobileAuditorium
